<template>
  <fvSelect
    class="form-control select text-right fv-size-md"
    v-model="valData"
    :options="options"
    :placeholder="placeholder"
    text-key="title"
    value-key="id"
    @search="fetchData"
    :search="true"
    :multiple="multiple"
    :loading="loading"
  >
    <template slot="value" slot-scope="scope">
      {{ findValueObject(scope.value).title }}
    </template>

    <template slot="option" slot-scope="scope">
      <div class="imageWithName">
        <span class="dropdown-item-text">
          <b>{{ scope.option.title || "---" }} </b>
        </span>

        <div class="dropdown-item-text">
          <img
            class="icon"
            v-if="scope.option.banner && scope.option.banner.path"
            :src="`${media_url}/${scope.option.banner.path}`"
          />

          <div v-else>
            <i class="far fa-kiss-beam defaultIcon" />
          </div>
        </div>
      </div>
    </template>
  </fvSelect>
</template>

<script>
import { mapActions } from "vuex";
import { API_MEDIA_URL } from "../env";

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    id: {
      type: String,
    },
    value: {
      type: [Array, String],
    },
    required: [Boolean, Function],
    justId: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ...mapActions("main", ["crud"]),
      options: [],
      media_url: API_MEDIA_URL,
      loading: false,
      filters: {},
    };
  },
  created() {
    this.getData(true);
  },
  computed: {
    valData: {
      get() {
        return this.value
          ? this.justId
            ? [this.value]
            : this.value
          : this.multiple
          ? []
          : undefined;
      },
      set(value) {
        const data = this.multiple ? value : [value];
        const result = this.justId ? data[0] : data;
        this.$emit("input", result);
      },
    },
  },
  methods: {
    findValueObject(value) {
      if (this.multiple)
        return this.options.find((option) => option.id === value) || false;
      else
        return this.options.find((option) => option.id === value[0]) || false;
    },
    fetchData(event) {
      clearTimeout(this.timingFetch);
      this.timingFetch = setTimeout(async () => {
        if (!event.trim()) {
          this.stories = [];
          this.loading = false;
          return false;
        }
        this.filters.title = event;
        await this.getData();
      }, 1000);
    },
    async getData(first = false) {
      const filters = {};
      if (this.type) filters.roles = this.type;

      if (first)
        if (this.value && this.value.length) filters.id = { $in: this.value };

      if (this.filters.title) filters.title = this.filters.title;

      this.loading = true;
      try {
        const category = await this.crud({
          action: "get",
          section: "categories",
          // query: `${this.$queryGenerator(filters, '')}`,
          perPage: 1000,
        });
        const result = category.data.items;
        this.options = result;
      } catch (e) {
        // console.log(e)
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
</style>
